export default __webpack_public_path__ + "static/media/u4.1a92be0c.jpg";